import {GetterTree} from 'vuex'
import {StatisticState} from './types';
import {RootState} from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
    cdpStaticDetail: state => state.cdpStaticDetail,
    cdpStatisticDetailFlag: (state) => state.cdpStatisticDetailFlag,
    cdpStatisticGroup: (state) => state.cdpStatisticGroup,
    cdpGroupBy: (state) => state.cdpGroupings.cdpGroup,
    cdpGroupByOptionally: (state) => state.cdpGroupings.cdpGroupByOptionally,
};
